import { Injectable } from "@angular/core";
import { toLower } from "lodash-es";

@Injectable()
export class AvatarService {
  private avatarsMap: Map<string, string> = new Map();

  register(key: string, url: string): void {
    this.avatarsMap.set(key, url);
  }

  get(key: string): string | undefined {
    return this.avatarsMap.get(key);
  }

  getForPatient(species: string): string {
    switch (toLower(species)) {
      case "dog": {
        return "https://www.cartoonizemypet.com/builder/thumbs/pets/dogs/akita-inu/red-db.png";
      }
      case "cat": {
        return "https://www.cartoonizemypet.com/builder/thumbs/pets/cats/british-shorthair/lynx-point-blue1.png";
      }
      default: {
        return "https://www.cartoonizemypet.com/builder/thumbs/pets/dogs/akita-inu/red-db.png";
      }
    }
  }
}
